{
  "name": "uploadthing",
  "version": "6.3.3",
  "engines": {
    "node": ">=18.13.0"
  },
  "license": "MIT",
  "exports": {
    "./package.json": "./package.json",
    "./client": {
      "types": "./dist/client.d.ts",
      "import": "./dist/client.mjs",
      "require": "./dist/client.js"
    },
    "./server": {
      "types": "./dist/server.d.ts",
      "import": "./dist/server.mjs",
      "require": "./dist/server.js"
    },
    "./next": {
      "types": "./dist/next.d.ts",
      "import": "./dist/next.mjs",
      "require": "./dist/next.js"
    },
    "./next-legacy": {
      "types": "./dist/next-legacy.d.ts",
      "import": "./dist/next-legacy.mjs",
      "require": "./dist/next-legacy.js"
    },
    "./express": {
      "import": "./dist/express.mjs",
      "types": "./dist/express.d.ts",
      "require": "./dist/express.js"
    },
    "./tw": {
      "types": "./dist/tw.d.ts",
      "import": "./dist/tw.mjs",
      "require": "./dist/tw.js"
    },
    "./fastify": {
      "types": "./dist/fastify.d.ts",
      "import": "./dist/fastify.mjs",
      "require": "./dist/fastify.js"
    },
    "./h3": {
      "types": "./dist/h3.d.ts",
      "import": "./dist/h3.mjs",
      "require": "./dist/h3.js"
    }
  },
  "files": [
    "dist"
  ],
  "publishConfig": {
    "access": "public"
  },
  "typesVersions": {
    "*": {
      "client": [
        "dist/client.d.ts"
      ],
      "server": [
        "dist/server.d.ts"
      ],
      "next": [
        "dist/next.d.ts"
      ],
      "next-legacy": [
        "dist/next-legacy.d.ts"
      ],
      "tw": [
        "dist/tw.d.ts"
      ],
      "express": [
        "dist/express.d.ts"
      ],
      "fastify": [
        "dist/fastify.d.ts"
      ],
      "h3": [
        "dist/h3.d.ts"
      ]
    }
  },
  "scripts": {
    "lint": "eslint \"**/*.{ts,tsx}\" --max-warnings 0",
    "build": "tsup",
    "clean": "git clean -xdf dist node_modules",
    "dev": "tsup --watch",
    "test": "vitest run",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit"
  },
  "dependencies": {
    "@uploadthing/mime-types": "^0.2.2",
    "@uploadthing/shared": "^6.2.1",
    "consola": "^3.2.3",
    "std-env": "^3.7.0"
  },
  "devDependencies": {
    "@types/express": "^4.17.17",
    "@types/react": "18.2.33",
    "@uploadthing/eslint-config": "0.2.0",
    "@uploadthing/tsconfig": "0.1.0",
    "@uploadthing/tsup-config": "0.1.0",
    "eslint": "^8.56.0",
    "express": "^4.18.2",
    "fastify": "^4.23.2",
    "h3": "^1.8.1",
    "next": "14.0.1",
    "solid-js": "^1.7.11",
    "tailwindcss": "^3.4.1",
    "tsup": "6.7.0",
    "type-fest": "^3.11.1",
    "typescript": "^5.3.3",
    "undici": "^6.5.0",
    "vitest": "^1.2.2",
    "zod": "^3.22.4"
  },
  "eslintConfig": {
    "root": true,
    "extends": [
      "@uploadthing/eslint-config/base"
    ],
    "rules": {
      "no-console": "error",
      "no-restricted-globals": [
        "error",
        {
          "name": "fetch",
          "message": "fetch should be passed as parameter to support overriding default behaviors"
        },
        {
          "name": "process",
          "message": "Use `import { process } from 'std-env` instead"
        }
      ]
    }
  }
}
